import { render } from "./VehicleTable.vue?vue&type=template&id=6cc76f8b"
import script from "./VehicleTable.vue?vue&type=script&lang=js"
export * from "./VehicleTable.vue?vue&type=script&lang=js"

import "./VehicleTable.vue?vue&type=style&index=0&id=6cc76f8b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__